export default __webpack_public_path__ + "static/media/industry-icon.f082eb38.svg";